import React, { useState } from "react";
import { ChevronLeft, ChevronRight, Images } from "lucide-react";
import { imgSrc } from "@/lib/img";
import { usePrefs } from "@/contexts/PrefsContext";

export const Gallery = ({ images, alt }: { images: string[]; alt: string }) => {
  const { t } = usePrefs();
  const [i, setI] = useState(0);
  const n = images.length;
  if (!n) return <div className="aspect-[16/10] rounded-[2rem] bg-muted" />;
  const go = (d: number) => setI((x) => (x + d + n) % n);
  const arrow = "absolute top-1/2 -translate-y-1/2 h-11 w-11 grid place-items-center rounded-full bg-black/40 text-white backdrop-blur hover:bg-black/60 transition-[background-color]";
  return (
    <div className="space-y-3" data-testid="venue-gallery">
      <div className="relative aspect-[4/3] sm:aspect-[16/9] overflow-hidden rounded-[2rem] bg-muted">
        {images.map((src, k) => (
          <img
            key={src + k}
            src={imgSrc(src)}
            alt={alt}
            className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-500 ${k === i ? "opacity-100" : "opacity-0"}`}
          />
        ))}
        {n > 1 && (
          <>
            <button data-testid="gallery-prev-button" onClick={() => go(-1)} className={`${arrow} start-3`}>
              <ChevronRight className="h-5 w-5 ltr:rotate-180" />
            </button>
            <button data-testid="gallery-next-button" onClick={() => go(1)} className={`${arrow} end-3`}>
              <ChevronLeft className="h-5 w-5 ltr:rotate-180" />
            </button>
          </>
        )}
        <span className="absolute bottom-3 end-3 inline-flex items-center gap-1 rounded-full bg-black/50 text-white text-xs font-bold px-3 py-1 backdrop-blur" data-testid="gallery-counter">
          <Images className="h-3.5 w-3.5" />
          {i + 1} / {n}
        </span>
      </div>
      {n > 1 && (
        <div className="flex gap-2 overflow-x-auto no-scrollbar">
          {images.map((src, k) => (
            <button
              key={src + k}
              data-testid={`gallery-thumb-${k}`}
              onClick={() => setI(k)}
              aria-label={`${k + 1} ${t("details.photos")}`}
              className={`shrink-0 h-16 w-20 overflow-hidden rounded-2xl border-2 transition-[border-color,opacity] ${k === i ? "border-primary" : "border-transparent opacity-70"}`}
            >
              <img src={imgSrc(src)} alt="" className="h-full w-full object-cover" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
